import $ from 'jquery';

export default () => {
  if ($('.share-buttons').length && document.querySelector('#main-row-column')) {
    import(/* webpackChunkName: "share-buttons" */ './share-buttons')
      .then(module => module.default())
      // eslint-disable-next-line no-unused-vars
      .catch(error => 'An error occurred while loading search-filters');
  }
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/social/index.js